<template>
    <div class="whatsapp-support-line" v-bind:class="{'mobile': $isMobile}">
        <a :href="url" target="_blank" rel="noopener nofollow">
            <div id="whatsappSupport" class="" >
              <div class="buttons columns is-gapless" v-bind:class="{'is-mobile': $isMobile}">
                <div class="column is-4 icon is-middle">
                  <div class="whatsapp-icon"></div>
                </div>
                <div class="column text-container is-middle" v-bind:class="{'mobile': $isMobile}">
                  <span v-html="$t('texts.whatsappHTML')"></span>
                </div>                
              </div>
            </div>
        </a>
   </div>
 </template>
 <script>
 export default {
   name: 'WhatsApp',
   data () {
     return {
       url: 'https://api.whatsapp.com/send/?phone=908502226660&text=Merhaba&type=phone_number&app_absent=0'
     }
   },
   mounted () {
   },
   methods: {},
   watch: {}
 }
 </script>
 <style>
 .whatsapp-support-line {
   margin: 5px;
 }
 .whatsapp-support-line .text-container {
   font-size: 14px;
   line-height: 103%;
 }
 .whatsapp-support-line .text-container.mobile {
   font-size: 12px;
 }
 .whatsapp-support-line .icon {
   display: flex;
   justify-content: center;
   align-items: center;
   height: 100%;
 }
 .whatsapp-support-line.mobile {
   margin: auto;
 }
 .whatsapp-support-line a {
   color: var(--text-color4);
 }
 .whatsapp-support-line a:hover {
   color: var(--text-color4) !important;
 }
 

 
@media only screen and (max-width: 1280px) and (min-width: 768px){
  .whatsapp-support-line .text-container {
    display: none;  
  }
  .whatsapp-support-line .icon {
    display: block;
  }
}

 </style>
 


// WEBPACK FOOTER //
// src/shared/widget/header/whatsapp.vue